import React from 'react';

const AddElementSectionButton = (props) => {

    const handleClick = () => {
        console.log('clicked');
    }

    return (
        <div style={{position:'relative', marginTop: '10px'}}>
            <div className='button' onClick={() => handleClick()}>Add Section</div>
        </div>
    )
}

export default AddElementSectionButton;